import { AbilityContext, Can } from '../../../../context/Ability';
import { TabPanel } from '@mui/lab';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { Chat } from './Chat';
import GiftPreview from '../common/GiftPreview';
import EditPreview from '../common/EditPreview';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { useSelector } from 'react-redux';
import { selectMyPreviousForms, selectRejectReason, selectShowMyHistory } from '../../giftSlice';
import RejectReason from '../common/RejectReason';
import { useContext } from 'react';
import { selectCurrentUserEmpCode } from '../../../Auth/authSlice';
import SwipeEdge from '../../../../common/SwipeEdge';
import PreviousGift from '../common/PreviousGift';
import FullScreen from '../common/FullScreen';
import { variants } from '../../../../variants/variants';

const MyGift = () => {
  const showHistory = useSelector(selectShowMyHistory);
  const reason = useSelector(selectRejectReason);
  const forms = useSelector(selectMyPreviousForms);
  const ability = useContext(AbilityContext);
  const userEmpcode = useSelector(selectCurrentUserEmpCode);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return (
    ability.can('read', 'GiftForm') && (
      <TabPanel
        value="mygift"
        sx={{
          width: 1,
          p: 0,
          height: `calc(100vh - ${isMobile?'135px':'130px'})`,
          // height: `100%`,
          // border:"1px solid red"
        }}
      >
        <Grid container sx={{ height: '100%' }}>
          
          {showHistory ? (
            <PreviousGift forms={forms} showEmployee={false} />
          ) : (
            <Can I={'create'} a={'GiftForm'}>
              <Chat />
            </Can>
          )}
          {!isMobile && (
            <>
              <GiftPreview>
                <RejectReason />
              </GiftPreview>
              <FullScreen />
            </>
          )}
          <EditPreview />
        </Grid>
        <SwipeEdge
          title={'GIFT preview'}
          // drawerBleeding={showHistory ? 0 : 56}
          drawerBleeding={0}
          content={
            <GiftPreview>
              <RejectReason />
            </GiftPreview>
          }
        />
      </TabPanel>
    )
  );
};

export default MyGift;
